import { createAsyncThunk } from "@reduxjs/toolkit";
import NotifyConfig from "../../utils/NotifyConfig";
import MyLessonsService from "../services/myLessonsService";

export const MyLessonsThunk = createAsyncThunk("myLessons/get", async () => {
  try {
    const response = await MyLessonsService.getMyLessonsData();

    return response;
  } catch (err) {
    NotifyConfig.notifyErrorServer(err.response?.data?.error?.text);
    console.error(err);
  }
});
